import './Header.css';
import {
  GridRow,
  GridColumn,
  Icon,
  List,
  ListItem,
  SemanticICONS,
  ListContent,
  Header as Title,
  HeaderSubheader
} from 'semantic-ui-react';
import { FormattedMessage, useIntl } from 'react-intl';
import { hasTranslation } from '../../guards/hasTranslation';

interface IInfoItem {
  icon: SemanticICONS;
  content: string;
}

const infoItems: Record<string, Array<IInfoItem>> = {
  en: [
  { icon: 'envelope outline', content: 'dreamer52773@gmail.com' },
  { icon: 'whatsapp', content: '+34 697 940 647' },
  { icon: 'linkedin', content: 'linkedin.com/in/pavelpivkin' },
  { icon: 'map marker alternate', content: 'header.address' },
  ],
  ru: [
    { icon: 'envelope outline', content: 'pivkin.pavel.11@yandex.ru' },
    { icon: 'whatsapp', content: '+7 (993) 607-06-95' },
    { icon: 'map marker alternate', content: 'header.address' },
  ],
}

export function Header() {
  const intl = useIntl();

  const displayItems = infoItems[intl.locale];
  
  return (
    <GridRow className="cv-header">
      <GridColumn width={3} className="my-photo__wrapper">
        <div className="my-photo"></div>
      </GridColumn>
      <GridColumn width={8}>
        <Title size='large'>
          <FormattedMessage id="header.Pavel Pivkin" />
          <HeaderSubheader><FormattedMessage id="header.vocation" /></HeaderSubheader>
        </Title>
        <div><FormattedMessage id="header.profile" /></div>
      </GridColumn>
      <GridColumn width={5}>
        <List>
          {
            displayItems.map((item) => (
              <ListItem>
                <Icon name={item.icon} />
                <ListContent>
                  {hasTranslation(item.content)
                    ? <FormattedMessage id={item.content} />
                    : item.content
                  }
                </ListContent>
              </ListItem>
            ))
          }
        </List>
      </GridColumn>
    </GridRow>
  );
}
